import { render, staticRenderFns } from "./NewReservationConfirm.vue?vue&type=template&id=06042f8e&scoped=true&"
import script from "./NewReservationConfirm.vue?vue&type=script&lang=js&"
export * from "./NewReservationConfirm.vue?vue&type=script&lang=js&"
import style0 from "./NewReservationConfirm.vue?vue&type=style&index=0&id=06042f8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06042f8e",
  null
  
)

export default component.exports